<script setup>
const props = defineProps({loading: Boolean})
</script>

<template>
  <div v-if="loading" class="item-search structure-waiting sticky-bottom">
    <div class="icon-container">
      <div class="icon-search loading"/>
    </div>
    <div class="content-search">
      <div class="search-title-link">
        <div class="search-title">
          <div class="language-one loading"/>
        </div>
      </div>
      <div class="search-hierarchy">
        <div class="loading"/>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.sticky-bottom {
  z-index: 20;
  position: sticky;
  bottom: 0;
}
</style>
